import React from 'react';

import cn from 'classnames';

type EmptyBlockProps = {
  Icon?: React.ComponentType<React.SVGProps<SVGSVGElement> & { className?: string }>;
  title?: string;
  description?: string;
  className?: string;
};

export const EmptyBlock: React.FC<EmptyBlockProps> = ({
  Icon,
  title = 'No stability data available yet',
  description = 'Please enter clinical indicators to determine the current stability level',
  className,
}) => {
  return (
    <div className={cn('flex flex-col content-between w-full max-w-[768px] mx-auto', className)}>
      <div className="monitor-stability flex flex-col items-center  bg-white-400 dark:bg-gray-900 shadow-section py-[4.5rem] px-6 rounded-2xl">
        {Icon ? (
          <Icon className="w-20 h-20 p-5 bg-white-300 rounded-2xl mb-4" />
        ) : (
          <div className="w-20 h-20 p-5 bg-white-300 rounded-2xl mb-4" />
        )}
        <p className="font-semibold text-center dark:text-white-400 ">{title}</p>
        <span className="text-sm max-w-[21rem] text-center dark:text-white-400 ">{description}</span>
      </div>
    </div>
  );
};

export default EmptyBlock;
